

const stepReducer = (state = "upload", action) => {

    switch(action.type){
        case "nextStep":
            return "edit"
        default:
            return state
    }
}

export default stepReducer